var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1685_3175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1685_3175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V52H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1685_3175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 26C50 31.1 48.5 36.2 45.8 40.4C43.1 44.7 39.1 48 34.6 50C30 52 25 52.5 20.2 51.5C15.3 50.5 10.9 48 7.39995 44.4C3.89995 40.8 1.49995 36.1 0.599955 31.1C-0.300045 26.1 -4.51803e-05 20.8 1.89995 16C3.79995 11.3 6.99996 7.2 11.1 4.4C15.2 1.5 20.1 0 25 0C31.6 0 38 2.7 42.7 7.6C47.4 12.5 50 19.1 50 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1999 31.0002V19.9002L30.2999 25.5002L22.1999 31.0002ZM39.1999 20.1002C39.1999 18.9002 38.7999 17.8002 37.9999 17.0002C37.1999 16.2002 36.0999 15.7002 34.9999 15.7002H14.9999C13.8999 15.7002 12.7999 16.2002 11.9999 17.0002C11.1999 17.8002 10.7999 19.0002 10.7999 20.1002V31.9002C10.7999 33.1002 11.2999 34.2002 11.9999 35.0002C12.7999 35.8002 13.8999 36.3002 14.9999 36.3002H34.9999C36.0999 36.3002 37.1999 35.8002 37.9999 35.0002C38.7999 34.2002 39.1999 33.0002 39.1999 31.9002V20.1002Z",
    fill: "#E60012"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1685_3175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube01);
export default __webpack_public_path__ + "static/media/youtube01.ae667ef0be5b4416bec053207649c0b3.svg";
export { ForwardRef as ReactComponent };